import {IVideoPlayerViewModel} from "../../services/video/models/video-player.view-model.interface";
import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import {VideoPlayerBox} from "./boxes/video-player.box";
import {VideoElementContainerBox} from "./boxes/video-element-container.box";
import {VideoPlayButtonComponent} from "./play-button/video-play-button.component";
import {VideoErrorComponent} from "./error/video-error.component";
import {VideoTypeEnum} from "../../services/video/models/video-type.enum";
import {NullableUndefinedString} from "../../../common/types/nullable-types";
import {VideoWatchTimeLimitReachedComponent} from "./watch-limit/video-watch-time-limit-reached.component";
import {TimeSpan} from "@sparkware/app-utils";


interface VideoPlayerComponentProps {
    videoPlayer: IVideoPlayerViewModel;
    src: string;
    isActive: boolean;
    videoType: VideoTypeEnum;
    poster: NullableUndefinedString;
}
export const VideoPlayerComponent: React.FC<VideoPlayerComponentProps> = observer((props) => {

    const videoElementContainerRef = useRef<HTMLDivElement | null>(null);
    const {videoPlayer, src, isActive, videoType, poster} = props;

    const watchTimeLimit = videoType === VideoTypeEnum.LiveStream ? TimeSpan.fromMinutes(2) : undefined

    useEffect(() => {
        videoPlayer.attach(videoElementContainerRef.current);

        return () => {
            videoPlayer.detach();
        }

    }, [videoPlayer]);

    useEffect(() => {
        let pauseTimerRef: any = null;
        if(isActive) {
            videoPlayer.play(src, {
                poster: poster,
                watchTimeLimit: watchTimeLimit
            });
        } else {
            videoPlayer.preload(src, {
                poster: poster
            }).then(() => {
                pauseTimerRef = setTimeout(async () => {
                    if(!isActive) {
                        await videoPlayer.pause();
                    }
                }, videoType === VideoTypeEnum.LiveStream ? 2000 : 5000);
            });
        }

        return () => {
            if(pauseTimerRef) {
                clearTimeout(pauseTimerRef);
                pauseTimerRef = null;
            }
        }

    }, [videoPlayer, src, isActive, poster, videoType, watchTimeLimit]);

    return (
        <VideoPlayerBox >
            <VideoElementContainerBox ref={videoElementContainerRef}/>
            <VideoPlayButtonComponent videoPlayer={props.videoPlayer}
                                      src={props.src}
                                      poster={props.poster}
                                      watchTimeLimit={watchTimeLimit}/>
            <VideoErrorComponent videoPlayer={props.videoPlayer}/>
            <VideoWatchTimeLimitReachedComponent videoPlayer={props.videoPlayer}/>
        </VideoPlayerBox>
    );
})